import { conditionProgramLoanTypeApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const PROGRAM_LOAN_ACTION_TYPE = createNamedActions('programLoan', {
  GET_PROGRAM_LOAN_TYPES: 'GET_PROGRAM_LOAN_TYPES',
});

export const getProgramLoanTypesAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await conditionProgramLoanTypeApi.getConditionProgramLoanType();

  return dispatch({
    type: PROGRAM_LOAN_ACTION_TYPE.GET_PROGRAM_LOAN_TYPES,
    payload: data,
  });
});
